var cibKhanAcademy = ["32 32", "<path d='M3.292 29.86c0 0-4.932-11.787 3.911-20.579 8.016-7.989 20.131-9.229 22.229-9.281 0 0 3.256 10.677-4.864 22.776-8.109 12.099-19.365 8.817-19.365 8.817s11.115-14.167 9.776-14.083c-0.932 0.057-6.765 6.473-11.687 12.353z'/>"];

export { cibKhanAcademy };

